<template>
  <div>
    <b-modal
      :id="id"
      ref="modal"
      hide-footer
      title="Confirmation">
      <p>{{message}}</p>
      <b-row>
        <b-col class="flex f-center">
          <b-link class="blinki-close-btn" @click="resetModal()">Annuler</b-link>
        </b-col>
        <b-col>
          <b-button class="mt-2 blinki-submit-btn" type="button" @click="handleOk" variant="primary">D'accord</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  export default {
    props:['msg'],
    methods: {
      resetModal() {
        this.$store.dispatch('confirm/unsetParams');
        this.$bvModal.hide(this.id)
      },
      handleOk() {
        const params = this.$store.state.confirm.params;
        const action = this.$store.state.confirm.action;
        this.$store.dispatch(action, params);
        this.$bvModal.hide(this.id);
      }
    },
    computed: {
      message(){
        return this.msg ? this.msg : 'Êtes-vous sûr(e) de vouloir supprimer définitivement l\'élément'
      },
      id(){
        return this.msg ? 'confirm-store-modal' : 'confirm-modal'
      }
    }
  }

</script>
